import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import dispatch, { MiddlewareAction } from "../middleware";
import { ReduxState } from "../reducers";

type UseEnableDashboardStatsProps = {
  action: MiddlewareAction;
};

type UseEnableDashboardStatsReturnType = {
  isEnabled: boolean;
};

export function useEnableDashboardStats({
  action,
}: UseEnableDashboardStatsProps): UseEnableDashboardStatsReturnType {
  const storeDispatch = useDispatch();
  const dashboardStatsEnabled = useSelector(
    (state: ReduxState) =>
      state.lender.lenderConfig?.config?.enableDashboardStats
  );

  const enableDashboardStats = useCallback(() => {
    dispatch(storeDispatch, action);
  }, [storeDispatch, action]);

  useEffect(() => {
    if (dashboardStatsEnabled == null) {
      enableDashboardStats();
    }
  }, [enableDashboardStats, dashboardStatsEnabled]);

  return {
    isEnabled: dashboardStatsEnabled !== false,
  };
}
